import { IButtonField } from "../IForm.types";
const GENERAL_BUTTON_COMPONENT_PROPERTIES = {
    autofocus: false,
    input: true,
    tableView: false,
    size: 'md',
    leftIcon: '',
    rightIcon: '',
    block: false,
    theme: 'primary',
    type: 'button',
  };
  
export class ButtonForm {
    width= 6;
    offset= 0;
    push= 0;
    pull= 0;
    components= [];
    constructor(button: IButtonField) {
        this.width = button.width;
        this.components.push({
            ...GENERAL_BUTTON_COMPONENT_PROPERTIES,
            ...button
        })

    }
}